
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo(0, 0);

    // Add page timing metrics
    if (window.performance && window.performance.mark) {
      const navStart = performance.now();
      window.performance.mark('page_navigation_start');
      
      // Add performance measurement after the page loads
      window.addEventListener('load', () => {
        window.performance.mark('page_navigation_end');
        window.performance.measure('page_navigation', 'page_navigation_start', 'page_navigation_end');
        
        // Log navigation timing for potential SEO optimization
        console.log(`Page navigation to ${pathname} took ${performance.now() - navStart}ms`);
      });
    }

    // Add structured data for the current page to help with SPA indexing
    const routeMap = {
      '/': 'HomePage',
      '/boleto-parcelado': 'ProductPage',
      '/antecipacao': 'ProductPage',
      '/cadastro-express': 'ServicePage',
      '/acesse-portais': 'WebPage',
      '/sobre': 'AboutPage',
      '/atendimento': 'ContactPage',
      '/faq': 'FAQPage'
    };

    // Add route-specific schema.org data
    const pageType = routeMap[pathname] || 'WebPage';
    const scriptId = 'dynamic-page-schema';
    let dynamicScript = document.getElementById(scriptId);
    
    if (!dynamicScript) {
      dynamicScript = document.createElement('script');
      dynamicScript.id = scriptId;
      // Fix: Use setAttribute instead of accessing the 'type' property directly
      dynamicScript.setAttribute('type', 'application/ld+json');
      document.head.appendChild(dynamicScript);
    }
    
    // Simple structured data to help search engines understand the current page
    dynamicScript.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': pageType,
      'url': `https://drcash.com.br${pathname}${search}`,
      'name': document.title
    });

  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
